import { render, staticRenderFns } from "./category-custom.vue?vue&type=template&id=207d4d26&scoped=true"
import script from "./category-custom.vue?vue&type=script&lang=js"
export * from "./category-custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d4d26",
  null
  
)

export default component.exports